// extracted by mini-css-extract-plugin
module.exports = {"container":"App_container__pG12X","image":"App_image__2EwJN"};